import { IntegrationService } from "./../integration.service";
import { put, select } from "redux-saga/effects";
import { updateHubspotPropertyFailure, updateHubspotPropertySuccess } from "../actionCreators";
import { UpdateHubspotPropertyRequestActionType } from "../types";

export function* updateHubspotPropertySaga(action: UpdateHubspotPropertyRequestActionType): Generator<any, void, any> {
    try {
        const { tableName, fields } = action.payload;
        const formId: string = yield select(state => state.forms.current._id);

        const formattedFields = Object.keys(fields).reduce((acc: any, key) => {
            acc[key] = fields[key];
            return acc;
        }, {});
        const data = { tableName, fields: formattedFields };

        const response = yield IntegrationService.updateHubspotProperty(formId, data);
        if (response.success) {
            yield put(updateHubspotPropertySuccess(response));
        } else {
            yield put(updateHubspotPropertyFailure(response.message || "Failed to update Hubspot Sheets config"));
        }
    } catch (error: any) {
        const errorMessage = error.response?.message || "Failed to update Hubspot Sheets";
        console.error("Error updating Hubspot Sheets config:", error);
        yield put(updateHubspotPropertyFailure(errorMessage));
    }
}
